module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Grunddaten bearbeiten","btn-save":"Speichern und schliessen"},"fr":{"title":"Éditer les données de base","btn-save":"Sauvegarder et fermer"},"it":{"title":"Modifica i dati di base","btn-save":"Salvare e chiudere"}}')
  delete Component.options._Ctor
}
